var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceGenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6375 0H12.9928L19.2267 6.49776V19.1359C19.2267 20.7191 17.9458 22 16.3681 22H5.6375C4.05429 22 2.77344 20.7191 2.77344 19.1359V2.86406C2.77341 1.28086 4.05426 0 5.6375 0Z",
    fill: "#E5252A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9873 0V6.44828H19.2267L12.9873 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.9563 16.415V12.3965H7.66595C8.08924 12.3965 8.42458 12.5119 8.67745 12.7483C8.93032 12.9792 9.05677 13.2925 9.05677 13.6828C9.05677 14.0731 8.93032 14.3865 8.67745 14.6174C8.42458 14.8538 8.08924 14.9692 7.66595 14.9692H6.98429V16.415H5.9563ZM6.98429 14.0952H7.55051C7.70442 14.0952 7.82536 14.0622 7.90784 13.9852C7.99028 13.9138 8.03429 13.8148 8.03429 13.6829C8.03429 13.5509 7.99031 13.452 7.90784 13.3805C7.82539 13.3036 7.70445 13.2706 7.55051 13.2706H6.98429V14.0952ZM9.48003 16.415V12.3965H10.9038C11.1842 12.3965 11.4481 12.435 11.6954 12.5174C11.9428 12.5999 12.1682 12.7153 12.3661 12.8748C12.564 13.0287 12.7234 13.2376 12.8388 13.5014C12.9488 13.7653 13.0093 14.0677 13.0093 14.4085C13.0093 14.7438 12.9488 15.0462 12.8388 15.31C12.7234 15.5739 12.564 15.7828 12.3661 15.9367C12.1682 16.0961 11.9428 16.2116 11.6954 16.294C11.4481 16.3765 11.1842 16.415 10.9038 16.415H9.48003ZM10.486 15.5409H10.7829C10.9423 15.5409 11.0907 15.5244 11.2282 15.4859C11.3601 15.4475 11.4865 15.387 11.6075 15.3045C11.7229 15.2221 11.8164 15.1066 11.8823 14.9527C11.9483 14.7988 11.9813 14.6174 11.9813 14.4085C11.9813 14.1941 11.9483 14.0127 11.8823 13.8588C11.8164 13.7049 11.7229 13.5894 11.6075 13.5069C11.4865 13.4245 11.3601 13.364 11.2282 13.3255C11.0907 13.2871 10.9423 13.2706 10.7829 13.2706H10.486V15.5409ZM13.526 16.415V12.3965H16.3846V13.2706H14.554V13.9137H16.0163V14.7823H14.554V16.415H13.526Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceGenerate);
export default __webpack_public_path__ + "static/media/invoice-generate.ee5c445ea87035ad9e2d43fd90da2e49.svg";
export { ForwardRef as ReactComponent };